import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { UseMutateFunction, useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { GroupsV2Api } from '../../../api-client';
import { getApiConfiguration } from '../../../common';
import { UpdateBusinessUnitData } from '../GroupDetails.types';

export const useUpdateBusinessUnits = (
  isAdding: boolean,
  groupId: string,
  closeDeleteBUModal?: () => void,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, UpdateBusinessUnitData>,
    'mutationFn'
  >,
): {
  updateBusinessUnit: UseMutateFunction<AxiosResponse<void>, ErrorResponse, UpdateBusinessUnitData>;
  isUpdating: boolean;
} => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const { showNotification } = useContext(NotificationsContext);
  const groupsV2Api = new GroupsV2Api(getApiConfiguration());
  const queryClient = useQueryClient();

  const onSuccess = () => {
    typeof closeDeleteBUModal === 'function' && closeDeleteBUModal();
    queryClient.invalidateQueries(`group-${groupId}-roles`).then();
    isAdding
      ? showNotification('Business unit successfully added!')
      : showNotification('Business unit successfully removed!');
  };

  const onError = () => showNotification('An error occurred!');

  const { mutate: updateBusinessUnit, isLoading: isUpdating } = useMutation(
    ({ groupId, roleId, bindings, isCustom }) =>
      groupsV2Api.updateGroupRole(tenantId, groupId, roleId, { bindings }, isCustom),
    {
      onSuccess,
      onError,
      ...options,
    },
  );

  return {
    updateBusinessUnit,
    isUpdating,
  };
};
